import { ToastContainer } from "react-toastify";
import { AuthProvider } from "./auth/authContext";
import AppRouter from "./router/appRouter";

function AppLayout({ initialAuth = null }) {
  return (
    <AuthProvider initialAuth={initialAuth}>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        theme="colored"
        pauseOnHover={false}
        draggable={false}
      />
      <div className="App">
        <AppRouter />
      </div>
    </AuthProvider>
  );
}

export default AppLayout;
